module.exports = __webpack_public_path__ + "static/media/18-30men.e86723d6.svg";